import { api } from './client'

export interface Agency {
  id: string
  name: string
  slug: string
  industry: string
  brandColor: string | null
  brandColorDark: string | null
  brandColor50: string | null
  logoUrl: string | null
  plan: string
  status: string
  currency: string
  /** IANA zone the agency operates in; sequence sending hours are interpreted in it. */
  timezone: string
  /** Who receives limbo escalations when the deal owner has no team lead; null = the first admin. */
  escalationUserId: string | null
  dealContactRoles: string[]
  leadSourceOptions: string[]
  contactFieldLayout: ContactFieldLayoutEntry[]
}

/** Display config for a core contact field. Array order = display order. */
export interface ContactFieldLayoutEntry {
  key: string
  label?: string
  hidden?: boolean
}

export interface UpdateAgencyParams {
  name: string
  brandColor?: string | null
  brandColorDark?: string | null
  brandColor50?: string | null
  logoUrl?: string | null
  /** Omit / null = keep the current currency unchanged (backend treats null as "no change"). */
  currency?: string | null
  /** Omit / null = keep the current list unchanged (backend treats null as "no change"). */
  dealContactRoles?: string[] | null
  /** Omit / null = keep the current list unchanged (backend treats null as "no change"). */
  leadSourceOptions?: string[] | null
  /** Omit / null = keep the current layout unchanged (backend treats null as "no change"). */
  contactFieldLayout?: ContactFieldLayoutEntry[] | null
  /** Omit / null = keep the current timezone unchanged. */
  timezone?: string | null
  /** An active admin's id; '' = back to the first admin; omit / null = keep unchanged. */
  escalationUserId?: string | null
}

export async function getAgency(): Promise<Agency> {
  const { data } = await api.get<Agency>('/api/agency')
  return data
}

/** Upload/replace the agency logo (multipart). Returns the agency with its new logoUrl. */
export async function uploadAgencyLogo(file: File): Promise<Agency> {
  const form = new FormData()
  form.append('file', file)
  // Null the default application/json so the browser sets multipart/form-data + boundary.
  const { data } = await api.post<Agency>('/api/agency/logo', form, {
    headers: { 'Content-Type': null },
  })
  return data
}

export async function updateAgency(params: UpdateAgencyParams): Promise<Agency> {
  const { data } = await api.put<Agency>('/api/agency', params)
  return data
}
